import styles from "./ProgressBar.module.css";

interface ProgressBarProps {
  value: number;
  label: string;
  tone?: "amber" | "indigo" | "cyan";
}

export const clamp01 = (v: number) => (Number.isFinite(v) ? Math.min(1, Math.max(0, v)) : 0);

export default function ProgressBar({ value, label, tone = "amber" }: ProgressBarProps) {
  const v = clamp01(value);
  return (
    <div
      className={styles.track}
      role="progressbar"
      aria-label={label}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={Math.round(v * 100)}
    >
      <div className={`${styles.fill} ${styles[tone]}`} style={{ width: `${v * 100}%` }} />
    </div>
  );
}
